module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUBAMAAACQZWsAAAAAMFBMVEUAAAD/aZb/aY/6aZH7aY/8aZD9aY/9aZD7aY/8aY/8aY/8aY/9aY/8aY/8aY/8aY/wq9I5AAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAAgklEQVQI12NgAILq3UCwywDEZH5eXl4+7+8FEJtlAwOD50+XD1C29XMFFhCbBcheCaRAbL7JDQxfoGzmlwxwNoPdBCj7/f///78gxGUmwNmMJxHqeSYVwNlsQPPh6nGyr7gA2axgdzJ07/7CwNSXwAABX1jWT4EyGV7cLYIxGbJACgD1JDwxIA1dJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logout-hover.png
// module id = 249
// module chunks = 0